// PayU Hosted Checkout helper (Pluxee card, and whatever else PayU shows on
// its own payment page for this MID).
//
// This is Hosted Checkout, not merchant-hosted: PayU's own page collects the
// card number/CVV/expiry, not ours. Our backend only ever sees the
// non-card order fields (txnid, hash, amount, etc.) via
// createPayUOrderFromCart, and this file only ever builds a redirect form
// out of those same non-card fields. Do not add ccnum/ccvv/ccexpmon/ccexpyr
// handling here — if PayU's Pluxee toggle for this MID ever turns out to
// need merchant-hosted (custom) checkout instead, that's a different,
// PCI-scoped flow and should not be bolted onto this one.

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://dailydish.in";

export const createPayUOrderFromCart = async (orderPayload) => {
  const response = await fetch(`${API_BASE_URL}/api/user/payu/create-order-from-cart`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(orderPayload),
  });

  const data = await response.json();
  if (!response.ok) {
    const err = new Error(data?.error || "Failed to create PayU order");
    err.response = { data };
    throw err;
  }
  return data;
};

/**
 * Builds a hidden form from the order fields PayU's Hosted Checkout needs
 * and submits it — a full-page navigation to PayU's own payment page. `pg`/
 * `bankcode` (MC/SODEXO) are included as a deep-link hint so PayU can send
 * the customer straight to the Pluxee entry screen instead of its generic
 * payment-method picker; if PayU ignores them for this MID, the customer
 * just sees the normal picker and selects Pluxee from there.
 *
 * @param {object} order - response from createPayUOrderFromCart
 */
export const redirectToPayUHostedCheckout = (order) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = order.payuBaseUrl;
  form.style.display = "none";

  const fields = {
    key: order.key,
    txnid: order.txnid,
    amount: order.amount,
    productinfo: order.productinfo,
    firstname: order.firstname,
    email: order.email,
    phone: order.phone,
    surl: order.surl,
    furl: order.furl,
    hash: order.hash,
    udf1: order.udf1,
    pg: order.pg,
    bankcode: order.bankcode,
  };

  Object.entries(fields).forEach(([name, value]) => {
    if (value === undefined || value === null) return;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
};
